import putFetcher from 'api/utils/putFetcher';
import { useCallback } from 'react';
import type { RenameTagReturn } from 'types/legacyDashboard';

interface UseRenameTagProps {
  tagId?: TagId;
  orgId?: OrgId;
}

const useRenameTagCall = ({ tagId, orgId }: UseRenameTagProps) => {
  const queryParams = new URLSearchParams({ orgid: `${orgId}` });
  const url = `${process.env.VITE_API_ROOT}/devices/tags/${tagId}/updatetagname/?${queryParams}`;

  const callback = useCallback(
    async (newName: string) => {
      if (!tagId || !orgId) {
        return undefined;
      }
      const result: RenameTagReturn | undefined = await putFetcher({
        url,
        body: { name: newName },
      });

      return result;
    },
    [orgId, tagId, url]
  );

  return callback;
};

export default useRenameTagCall;
